import { Component } from '@angular/core';

import { ApTokenSelectorSkeletonComponent } from '../token/selector/skeleton/skeleton.component';

@Component({
    selector: 'ap-sign-skeleton',
    standalone: true,
    template: '<ap-token-selector-skeleton [hasRememberControl]="true" [tokenTypesLength]="4"></ap-token-selector-skeleton>',
    imports: [ApTokenSelectorSkeletonComponent]
})
export class ApSignSkeletonComponent {}
